module.exports = __webpack_public_path__ + "static/media/more-icon-active.86204dc1.svg";